import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import About from './About';
import Spinner from '../common/Spinner/Spinner';
import config from '../../config';
import { setTheme } from '../../actions/layoutActions';


class AboutContainer extends Component {
  static propTypes = {
    setTheme: PropTypes.func.isRequired
  }

  state = {
    content: ''
  };

  async componentDidMount() {
    const res = await fetch(`${config.fetchURL}/pages?_embed&slug=rolam`);
    const data = await res.json();

    this.setState({ content: data[0].acf.sajat_oldal });
    this.props.setTheme('BLUE');
  }

  componentDidUpdate() {
    this.props.setTheme('BLUE');
  }

  render() {
    const { content } = this.state;

    if (content.length > 0) {
      return (
        <About content={content} />
      );
    } else {
      return (
        <Spinner style={{ marginTop: '200px', marginBottom: '200px' }} />
      );
    }
  }
}


export default connect(null, { setTheme })(AboutContainer);



// WEBPACK FOOTER //
// ./src/components/About/AboutContainer.js